
import React from "react";
import { Container } from "react-bootstrap";
import "../../css/Header.css";

export default function Header() {
    return (
        <Container fluid className="minmedia-header">
            <a href="/" className="minmedia-brand">
                <span className="minmedia-brand-name">
                    MinMedia
                </span>

                <span className="minmedia-brand-subtitle">
                    WEDDING · PHOTO · FILM
                </span>

                <span className="minmedia-brand-slogan">
                    Lưu giữ khoảnh khắc · Trọn vẹn yêu thương
                </span>
            </a>
        </Container>
    );
}
